import { unMaskCurrency } from '../../../../../utils/masks/unMaskCurrency.ts'
import { findAccountConfig } from '../../../constants/accountsConfig.ts'

import type { PreviaSemanalAccountProps, SubmitPreviaSemanalRequestProps } from '@services/api/consolidatedEntry/types'
import type { PreviaSemanalPayloadField } from '../../../constants/accountsConfig.ts'

export const buildSubmitPayload = (
  accounts: PreviaSemanalAccountProps[],
  values: Record<number, string>,
  referenceDate: string,
  branchCode: string
): SubmitPreviaSemanalRequestProps => {
  const amountsByField = accounts.reduce<Record<PreviaSemanalPayloadField, number>>(
    (amounts, account) => {
      const config = findAccountConfig(account.account)

      if (config) {
        amounts[config.payloadField] = unMaskCurrency(values[account.accountId])
      }

      return amounts
    },
    {
      billingAmount: 0,
      consumptionAmount: 0,
      peopleAmount: 0,
      otherExpensesAmount: 0,
      depreciationAmount: 0,
      bonusAmount: 0
    }
  )

  return {
    referenceDate,
    branchCode,
    ...amountsByField
  }
}
